module.exports = __webpack_public_path__ + "img/PhonePe.b1441e09.png";